window.addEventListener('SITE_START', () => {
  const $popup = document.querySelector('.home-main-popup');
  if (!$popup) return;

  const $swiper = $popup.querySelector('.swiper#main-popup-image');
  const $slides = $swiper.querySelectorAll('.swiper-slide');
  const $navigator = $swiper.querySelector('.swiper-navigator');
  const $prevBtn = $swiper.querySelector('.swiper-button-prev');
  const $nextBtn = $swiper.querySelector('.swiper-button-next');

  if ($slides.length <= 1 && $navigator) $navigator.style.display = 'none';

  new Swiper($swiper, {
    slidesPerView: 1,
    speed: 300,
    navigation: {
      prevEl: $prevBtn,
      nextEl: $nextBtn,
    },
    simulateTouch: true,
    allowTouchMove: true,
  });

  const $checkbox = $popup.querySelector('#today-close-checkbox');
  const $closeBtn = $popup.querySelector('.__close');

  const today = new Date().toISOString().slice(0, 10);
  const key = `hidePopup_${today}`;

  // 이미 오늘 닫은 적 있으면 안보이게
  if (localStorage.getItem(key)) {
    $popup.style.display = 'none';
    return;
  }

  // 닫기 버튼 클릭 시
  if ($closeBtn) {
    $closeBtn.addEventListener('click', () => {
      if ($checkbox.checked) localStorage.setItem(key, 'true');
      $popup.style.display = 'none';
    });
  }


  const $scrollableArea = $popup.querySelector('[data-scrollable]');

  if ($scrollableArea) {
    $scrollableArea.addEventListener('wheel', (e) => e.stopPropagation());
  }
});
